<template>
  <Teleport to="body">
    <div class="confetti-overlay" ref="container">
      <div
          v-for="item in confetti"
          :key="item.id"
          class="confetti-piece"
          :style="{
        transform: `translate(${item.x}px, ${item.y}px) rotate(${item.rotation}deg)`,
        width: item.size + 'px',
        height: item.size + 'px'
      }"
      >
        <img :src="item.src" alt="confetti"/>
      </div>
    </div>
  </Teleport>
</template>


<script>
import Confetti1a from '@/assets/image/platform/effects/Confetti/confetti_1a.svg'
import Confetti1b from '@/assets/image/platform/effects/Confetti/confetti_1b.svg'
import Confetti1c from '@/assets/image/platform/effects/Confetti/confetti_1c.svg'
import Confetti1d from '@/assets/image/platform/effects/Confetti/confetti_1d.svg'
import Confetti1e from '@/assets/image/platform/effects/Confetti/confetti_1e.svg'
import Confetti2a from '@/assets/image/platform/effects/Confetti/confetti_2a.svg'
import Confetti2b from '@/assets/image/platform/effects/Confetti/confetti_2b.svg'
import Confetti2c from '@/assets/image/platform/effects/Confetti/confetti_2c.svg'
import Confetti2d from '@/assets/image/platform/effects/Confetti/confetti_2d.svg'
import Confetti2e from '@/assets/image/platform/effects/Confetti/confetti_2e.svg'
import Confetti3a from '@/assets/image/platform/effects/Confetti/confetti_3a.svg'
import Confetti3b from '@/assets/image/platform/effects/Confetti/confetti_3b.svg'
import Confetti3c from '@/assets/image/platform/effects/Confetti/confetti_3c.svg'
import Confetti3d from '@/assets/image/platform/effects/Confetti/confetti_3d.svg'
import Confetti3e from '@/assets/image/platform/effects/Confetti/confetti_3e.svg'
import Confetti4a from '@/assets/image/platform/effects/Confetti/confetti_4a.svg'
import Confetti4b from '@/assets/image/platform/effects/Confetti/confetti_4b.svg'
import Confetti4c from '@/assets/image/platform/effects/Confetti/confetti_4c.svg'
import Confetti4d from '@/assets/image/platform/effects/Confetti/confetti_4d.svg'
import Confetti4e from '@/assets/image/platform/effects/Confetti/confetti_4e.svg'

export default {
  name: 'Confetti',

  props: {
    duration: {type: Number, default: 45000},
    amount: {type: Number, default: 200},
    spawnRate: {type: Number, default: 80},
    fadeDuration: {type: Number, default: 1500}
  },

  data() {
    return {
      confetti: [],
      running: false,
      animationFrame: null,
      spawnInterval: null,
      startTime: 0,
      fadeStartTime: 0,
      svgs: [Confetti1a, Confetti1b, Confetti1c, Confetti1d, Confetti1e,
        Confetti2a, Confetti2b, Confetti2c, Confetti2d, Confetti2e,
        Confetti3a, Confetti3b, Confetti3c, Confetti3d, Confetti3e,
        Confetti4a, Confetti4b, Confetti4c, Confetti4d, Confetti4e,],
    }
  },

  methods: {
    spawnOne() {
      const width = window.innerWidth

      this.confetti.push({
        id: Math.random(),
        src: this.svgs[Math.floor(Math.random() * this.svgs.length)],
        x: Math.random() * width,
        y: -50,
        rotation: Math.random() * 360,
        speed: 1 + Math.random() * 2,
        rotationSpeed: -2 + Math.random() * 4,
        size: 12 + Math.random() * 24,
        opacity: 1
      })
    },

    animate(timestamp) {
      if (!this.running) return

      if (!this.startTime) this.startTime = timestamp
      const elapsed = timestamp - this.startTime

      const fadePhase = elapsed >= this.duration

      this.confetti.forEach((c) => {
        c.y += c.speed
        c.rotation += c.rotationSpeed

        if (fadePhase) {
          if (!this.fadeStartTime) this.fadeStartTime = timestamp

          const fadeElapsed = timestamp - this.fadeStartTime
          const t = Math.min(fadeElapsed / this.fadeDuration, 1)

          c.opacity = 1 - t * t * t
        }
      })

      if (fadePhase) {
        this.confetti = this.confetti.filter((c) => c.opacity > 0.01)
      }

      if (elapsed < this.duration + this.fadeDuration + 200) {
        this.animationFrame = requestAnimationFrame(this.animate)
      } else {
        this.running = false
      }
    },

    start() {
      if (this.running) return

      this.running = true
      this.startTime = 0
      this.fadeStartTime = 0
      this.confetti = []

      this.spawnInterval = setInterval(() => {
        if (!this.running) return
        this.spawnOne()
      }, this.spawnRate)

      this.animationFrame = requestAnimationFrame(this.animate)

      setTimeout(() => {
        clearInterval(this.spawnInterval)
      }, this.duration)
    }
  },

  beforeUnmount() {
    cancelAnimationFrame(this.animationFrame)
    clearInterval(this.spawnInterval)
  }
}
</script>

<style scoped>
.confetti-overlay {
  position: fixed;
  inset: 0;
  z-index: 999999;
  overflow: hidden;
  pointer-events: none;
  width: 100%;
  height: min(100vh, calc(100vw * 0.5625));
}

.confetti-piece {
  position: absolute;
  top: 0;
  left: 0;
  will-change: transform, opacity;
  transition: opacity 1.2s ease-out;
}

.confetti-piece img {
  width: 100%;
  height: 100%;
}
</style>